export enum ProtocolType {
  Farming = 'Farming',
}

export interface IDeFiToken {
  icon: string;
  name: string;
}

export interface IDeFiItem {
  tokens: IDeFiToken[];
  network: string;
  networkIcon: string;
  protocol: string;
  protocolIcon: string;
  protocolType: ProtocolType;
  link: string;
}
